import { mobileApiRequest } from '../../apiRequests'

export const listDomainIntelligence = async (workspaceID) => {
    const action = {
        action: 'listDomainIntelligence',
        workspaceID,
    }
    return await mobileApiRequest(action)
}

export const getDomainIntelligenceFile = async (workspaceID, filePath) => {
    const action = {
        action: 'getDomainIntelligenceFile',
        workspaceID,
        filePath,
    }
    return await mobileApiRequest(action)
}

export const listDomainIntelligenceArtifacts = async (workspaceID) => {
    const action = {
        action: 'listDomainIntelligenceArtifacts',
        workspaceID,
    }
    return await mobileApiRequest(action)
}

export const getDomainIntelligenceArtifactFile = async (workspaceID, runPath, artifactPath) => {
    const action = {
        action: 'getDomainIntelligenceArtifactFile',
        workspaceID,
        runPath,
        artifactPath,
    }
    return await mobileApiRequest(action)
}

export const getDomainIntelligenceArtifactReport = async (workspaceID, runPath) => {
    const action = {
        action: 'getDomainIntelligenceArtifactReport',
        workspaceID,
        runPath,
    }
    return await mobileApiRequest(action)
}

export const generateDomainIntelligenceArtifactDocx = async (
    workspaceID,
    runPath,
    resynthesize = false
) => {
    const action = {
        action: 'generateDomainIntelligenceArtifactDocx',
        workspaceID,
        runPath,
        resynthesize,
    }
    return await mobileApiRequest(action)
}

export const updateDomainIntelligenceFile = async (workspaceID, filePath, content) => {
    const action = {
        action: 'updateDomainIntelligenceFile',
        workspaceID,
        filePath,
        content,
    }
    return await mobileApiRequest(action)
}

// Customer-facing Portal projection of a group run — the exact allowlisted JSON
// the Portal receives (assembled by PortalReportAssembler, validated by
// PortalReportContractValidator). Used by the operator "customer preview".
export const getDomainIntelligencePortalReport = async (workspaceID, runPath) => {
    const action = {
        action: 'getDomainIntelligencePortalReport',
        workspaceID,
        runPath,
    }
    return await mobileApiRequest(action)
}
